module.exports = __webpack_public_path__ + "img/AboutMTN2.5c086af2.png";